<script lang="ts">
  import { Play } from "$components/+blocks/OVIcon";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";

  export let src: string | null | undefined;
  export let isThumbnail = false;
  let className: string = "object-cover w-full h-full";
  export { className as class };

  // if the video is a thumbnail, we don't want to show the controls by default
  let controls = !isThumbnail;
  let paused = true;
</script>

<div class="relative">
  <video {src} {controls} class={className} on:error bind:paused>
    <track default kind="captions" />
  </video>
  {#if isThumbnail && (!controls || paused)}
    <button
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/10 p-3 shadow-md backdrop-blur-sm transition-transform hover:scale-105"
      type="button"
      on:click|preventDefault={() => {
        controls = true;
        paused = false;
      }}
    >
      <OVIcon icon={Play} class="ml-0.5" size="size-8 text-gray-300" />
    </button>
  {/if}
</div>
